import * as Sentry from '@sentry/angular';
/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';
import { isChunkLoadError, isReloadingForNewVersion } from './app/core/chunk-reload/chunk-reload';

if (environment.production) {
  Sentry.init({
    dsn: 'https://f0fa4fec45aebfdda77c8c5842d5c7f1@o4509809177722880.ingest.de.sentry.io/4511477357084752',
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1,
    enableLogs: true,
    sendDefaultPii: true,
    beforeSend: (event, hint) =>
      isReloadingForNewVersion() && isChunkLoadError(hint.originalException) ? null : event,
  });
}

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
